import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function IdsExpandMore(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path id="footprint" d="M24,24H0V0H24V24Z" fill="none"/>
      <path id="expand-more" d="M4.97,9.89c-.37-.32-.41-.88-.1-1.25,.3-.35,.8-.41,1.17-.15l.07,.06,5.88,5.07,5.88-5.07c.35-.3,.86-.28,1.18,.03l.06,.07c.3,.35,.28,.86-.03,1.19l-.07,.06-6.45,5.56c-.31,.26-.75,.28-1.08,.05l-.07-.05-6.45-5.56Z" fillRule="evenodd"/>
    </SvgIcon>
  ); 
}